import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { appendToRmaReviewsApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { PagedSearchReviewModel, SearchFilter } from './search-reviews.model';

@Injectable({
  providedIn: 'root',
})
export class SearchReviewsApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly reviewsApiUrl = inject(appendToRmaReviewsApiUrl);

  public searchReviews(filter: SearchFilter = {}): Observable<PagedSearchReviewModel> {
    return this.httpClient.post<PagedSearchReviewModel>(this.reviewsApiUrl(`Reviews/Search`), filter, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
